import { Common, color, Widget } from '@stockbit/ui';
import SUCCESS_MESSAGE from 'constants/successMessage';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../styled';

import slice, { effects, selectors } from './slice';
import { wlIdSelector } from '../slice';

const { Text, Flex } = Common;
const { Button } = Widget;

const { actions } = slice;

function DeleteModal() {
  const { isDeleteModalVisible, watchlistTobeDeleted, saved } =
    useSelector(selectors);
  const watchlistId = useSelector(wlIdSelector);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleDeleteClick = async () => {
    setLoading(true);
    const del = await dispatch(
      effects.deleteSelectedWatchlist({
        watchlistid: watchlistTobeDeleted,
        activeWatchlistId: watchlistId,
      }),
    );

    // @ts-ignore
    const { data } = del.payload;

    if (data) {
      setLoading(false);
      handleErrorMessageAPI(
        'Watchlist has been deleted',
        SUCCESS_MESSAGE.ALERT_GREEN,
      );
    }
  };

  const Title = (
    <Text size="16px" align="center" height="40px" family="bold">
      Delete Watchlist
    </Text>
  );

  const handleModalCancel = () => dispatch(actions.toggleDeleteModal({}));
  const activeWatchlist = saved.find(
    (item) => item.watchlist_id === watchlistTobeDeleted,
  );
  const watchlistName = activeWatchlist?.name || '-';

  return (
    <Modal
      title={Title}
      visible={isDeleteModalVisible}
      centered
      footer={null}
      onCancel={handleModalCancel}
    >
      <Text>Confirm delete {watchlistName} ?</Text>
      <Flex justify="flex-end" mt="15px">
        <Button height="40px" onClick={handleModalCancel} borderLess>
          <Text>Cancel</Text>
        </Button>
        <Button
          type="primary"
          height="40px"
          width="80px"
          onClick={handleDeleteClick}
          loading={loading}
          round
        >
          <Text color={color.light}>Delete</Text>
        </Button>
      </Flex>
    </Modal>
  );
}

export default DeleteModal;
